import { defineComponent as _defineComponent } from 'vue';
import { ref, onBeforeUnmount } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Modal',
    setup(__props, { expose: __expose }) {
        const isActive = ref(false);
        let lastFocusedEl = null;
        // TODO: Store last focused element on open and refocus on close
        function open() {
            lastFocusedEl = document.activeElement;
            isActive.value = true;
            // Enable scroll lock
            document.documentElement.style.overflowY = 'hidden';
            document.addEventListener('keydown', handleKeyDown);
        }
        function close(event) {
            isActive.value = false;
            // Disable scroll lock
            document.documentElement.style.removeProperty('overflow-y');
            document.removeEventListener('keydown', handleKeyDown);
            setTimeout(function () {
                var vueModalContainer = document.getElementById("vueContainer");
                if (vueModalContainer) {
                    vueModalContainer.classList.remove("activate-vue-modal");
                }
            }, 2000);
            event.stopPropagation();
            // Resume focus position on page from where it was before the modal opened
            if (lastFocusedEl instanceof HTMLElement) {
                lastFocusedEl.focus();
                lastFocusedEl = null;
            }
        }
        function handleKeyDown(ev) {
            if (ev.key === 'Escape') {
                close();
            }
        }
        onBeforeUnmount(() => close());
        __expose({
            open,
            close
        });
        const __returned__ = { isActive, get lastFocusedEl() { return lastFocusedEl; }, set lastFocusedEl(v) { lastFocusedEl = v; }, open, close, handleKeyDown };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
